import ConnectStatusComponent from './ConnectStatus';

const ConnectStatus: React.FC<{}> = () => {
  return <ConnectStatusComponent />;
};

export default ConnectStatus;
